import { useNavigate } from "react-router-dom";
import { FILE_BASE_URL } from "../../../apiConfig";
import { motion } from "framer-motion";
import { Calendar } from "lucide-react";

const PREMIUM_GRAD = 'linear-gradient(180deg, #0A1172 0%, #040960 100%)';

function NewsCard({ data, onClick }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick(data);
            return;
        }

        if (data.link) {
            if (data.link.startsWith('http')) {
                window.open(data.link, '_blank');
            } else {
                navigate(data.link);
            }
        } else {
            navigate('/news/' + data.id);
        }
    };

    return (
        <motion.div
            onClick={handleClick}
            whileHover="hover"
            style={{
                width: '100%',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                borderRadius: '12px',
                background: '#000',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                border: '1px solid rgba(255,255,255,0.05)',
            }}
        >
            {/* Image Section */}
            <div style={{
                width: '100%',
                height: '180px',
                position: 'relative',
                overflow: 'hidden',
                background: '#111',
            }}>
                <motion.img
                    variants={{
                        hover: { scale: 1.1 }
                    }}
                    transition={{ duration: 0.4 }}
                    src={`${FILE_BASE_URL}/${data.image}`}
                    alt={data.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
                
                {/* Date Badge (Glassmorphism) */}
                <div style={{
                    position: 'absolute',
                    top: '12px',
                    left: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '4px 10px',
                    background: 'rgba(0,0,0,0.6)',
                    backdropFilter: 'blur(8px)',
                    borderRadius: '4px',
                    border: '1px solid rgba(255,255,255,0.1)',
                    zIndex: 2,
                }}>
                    <Calendar size={12} color="#E7C424" />
                    <span style={{
                        fontFamily: "'Rajdhani', sans-serif",
                        fontSize: '11px',
                        fontWeight: 700,
                        color: '#fff',
                        letterSpacing: '0.5px'
                    }}>
                        {data.publish_date || 'RECENT'}
                    </span>
                </div>
            </div>

            {/* Details Section */}
            <motion.div 
                variants={{
                    hover: { backgroundColor: '#060D8A' }
                }}
                style={{
                    background: PREMIUM_GRAD,
                    padding: '16px',
                    width: '100%',
                    minHeight: '110px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: '12px',
                    boxSizing: 'border-box',
                    borderTop: '3px solid #E7C424', 
                    transition: 'background-color 0.3s ease',
                }}
            >
                <p style={{
                    fontFamily: "'Anton', sans-serif",
                    fontSize: '20px',
                    fontWeight: 400,
                    lineHeight: '1.2',
                    color: '#fff',
                    margin: 0,
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    textOverflow: 'ellipsis',
                    letterSpacing: '0.5px'
                }}>
                    {data.title}
                </p>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{
                        fontFamily: "'Rajdhani', sans-serif",
                        fontSize: '12px',
                        fontWeight: 600,
                        color: 'rgba(255, 255, 255, 0.7)',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    }}>
                        Read More
                    </span>
                    <motion.div 
                        variants={{
                            hover: { x: 5 }
                        }}
                        style={{ color: '#E7C424', fontSize: '14px' }}
                    >→</motion.div>
                </div>
            </motion.div>
        </motion.div>
    );
}

export default NewsCard;
